import axios from 'axios'
import 'url-search-params-polyfill'
import setActiveStep from './activeStepActions'
import setRestaurants from './setRestaurants'
import apiConfiguration from '../utilities/api/apiConfiguration'
import getCookie from '../utilities/session/getCookie'

// GA events handler
import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'

import _ from 'lodash'
import yn from 'yn'
import {getClientIdByHotelCode, getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const FETCH_ENHANCEMENTS_BEGIN   = 'FETCH_ENHANCEMENTS_BEGIN'
export const FETCH_ENHANCEMENTS_SUCCESS = 'FETCH_ENHANCEMENTS_SUCCESS'
export const FETCH_ENHANCEMENTS_FAILURE = 'FETCH_ENHANCEMENTS_FAILURE'

export const fetchEnhancementsBegin = urlParams => ({
	type: FETCH_ENHANCEMENTS_BEGIN,
	payload: urlParams
})

export const fetchEnhancementsSuccess = enhancements => ({
	type: FETCH_ENHANCEMENTS_SUCCESS,
	payload: enhancements
})

export const fetchEnhancementsError = error => ({
	type: FETCH_ENHANCEMENTS_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchEnhancementsData(urlData, roomTypeCode, ratePlanCode, roomGroup) {
	return (dispatch, getState) => {

		// Set default lang
		let currentLanguage = 'en'
		let hotelProvider = 0
		let sessionId = null
		let currencyCode = 'USD'
    let currentClientId = getClientIdByHotelCode(urlData.hotelCode);
		let currentEndpointUrl = getEndpointByHotelCode(urlData.hotelCode);

		// Use lang query param
		if (urlData.primaryLangId) {
			currentLanguage = urlData.primaryLangId
		}

		if (
			urlData &&
			urlData.hotelProvider
		) {
			hotelProvider = urlData.hotelProvider
		}

		// Use lang query param
		if (urlData.currency) {
			currencyCode = urlData.currency
		}

		if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') !== ''
		) {
			sessionId = getCookie('flowSessionId')
		}

		let enhancementUrlParams = {
			startDate: urlData.startDate,
			endDate: urlData.endDate,
			adults: urlData.adults,
			children: urlData.children,
			childAges: urlData.childAges,
			hotelCode: urlData.hotelCode,
			roomTypeCode: roomTypeCode,
			ratePlanCode: ratePlanCode,
			primaryLangId: currentLanguage,
			exactMatchOnly: true,
			availReqType: 'NonRoom',
			hotelProvider: hotelProvider,
			sessionId: sessionId,
			clientId: currentClientId,
			currency: currencyCode
		}

		let roomTypeEnhancements = {}

		// Fetch query string method
		const fetchEnhancementsQuery = new URLSearchParams()

		// Loop params for blank values
		for (let key in enhancementUrlParams) {
			if (typeof enhancementUrlParams[key] === "undefined") continue
			fetchEnhancementsQuery.append(key, enhancementUrlParams[key])
		}

		// Base API path
		let apiBase = currentEndpointUrl + '/api/hotel/services?'

		// Combine API URL & formatted enhancementUrlParams
		const fetchEnhancementsResult = apiBase + fetchEnhancementsQuery.toString()

		dispatch(fetchEnhancementsBegin())
		return axios.get(fetchEnhancementsResult, apiConfiguration())
			.then((response) => {

				if (!_.isEmpty(response.data['hydra:member'])) {
					// filter response for supported enhancement types
					const queriedEnhancements = response.data['hydra:member'].filter(enhancements => {
						let propertyEnhancements = []

						if (enhancements.type !== 'dining' && enhancements.type !== 'nightlife') {
							propertyEnhancements.push(
								enhancements.servicePricingType === 'Per stay' ||
								enhancements.servicePricingType === 'Per person' ||
								enhancements.servicePricingType === 'Per night' ||
								enhancements.servicePricingType === 'Per adult/stay'
							)
						}

						return propertyEnhancements
					})

					// sort out unique entries by serviceInventoryCode
					const uniqueEnhancements = _.uniqBy(queriedEnhancements, 'serviceInventoryCode')

					// construct enhancements object by roomType and ratePlan
					roomTypeEnhancements[roomTypeCode + '-' + ratePlanCode + '-' + roomGroup] = uniqueEnhancements

					// TEMP 7ROOMS INTEGRATIONS
					if(yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS)) {
						const queriedRestaurants = response.data['hydra:member'].filter(restaurants => {
							return restaurants.type === 'dining' || restaurants.type === 'nightlife'
						})

						dispatch(setRestaurants(queriedRestaurants))
					}

					// Dispatch initial GA events
					const trackedServicesData = {
						roomTypeCode,
						ratePlanCode,
						roomGroup,
						services: uniqueEnhancements,
					}

					triggerCustomGaEvent('analytics-servicesAvailable', trackedServicesData)

					dispatch(fetchEnhancementsSuccess(roomTypeEnhancements))
				} else {
					let activeRoomsAmount = Object.keys(getState().activeRoomData).length
					let currentMultiRoomStep = getState().multiRoomData.currentMultiRoomStep
					let multiRoomTotal = getState().multiRoomData.multiRoomTotal

					dispatch(fetchEnhancementsSuccess(null))

					// Allow for multi room and single room skipping preEnhancements to payment
					if (yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) && getState().activeStepData.activeStep === 1) {
						if (getState().multiRoomData.isMultiRoom) {
							if (activeRoomsAmount === multiRoomTotal && currentMultiRoomStep === multiRoomTotal - 1) {
								dispatch(setActiveStep(getState().activeStepData.activeStep + 1))
							}
						} else {
							dispatch(setActiveStep(getState().activeStepData.activeStep + 1))
						}
					}
				}
			})
			.catch(error => {
				dispatch(fetchEnhancementsError(error))
				dispatch(setActiveStep(getState().activeStepData.activeStep + 1))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchEnhancements.js